// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/await-thenable */

const imageApiUri = process.env.aerialPlotConnections.aerialImageApi.baseUrl + "api/v1/";
const aerialApiUri = process.env.aerialPlotConnections.aerialPlotApi.baseUrl + "api/v1/";

import * as orthoApi from "./orthoApi";
import _ from "lodash";

export function getFlightInfo(clientId, accessToken) {
	return fetch(aerialApiUri + "Flights/GetNewEditFlightInfo?clientId=" + clientId, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function saveNewFlight(flight, accessToken) {
	let flightT = _.cloneDeep(flight);
	flightT.flightDateTime = flightT.flightDateTime.toLocaleString();
	flightT.name = flightT.name?.trim();
	flightT.plan = flightT.plan?.trim();
	return fetch(aerialApiUri + "Flights", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(flightT),
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function updateFlight(flight, accessToken) {
	let flightT = _.cloneDeep(flight);
	flightT.flightDateTime = flightT.flightDateTime.toLocaleString();
	flightT.name = flightT.name?.trim();
	flightT.plan = flightT.plan?.trim();
	return fetch(aerialApiUri + "Flights", {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(flightT),
	}).then((res) => res);
}

export function getFlight(flightId, accessToken) {
	return fetch(aerialApiUri + "Flights?flightId=" + flightId, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function getFlightLogDataOptions(clientId, searchAllClients, accessToken) {
	return fetch(
		aerialApiUri + `Flights/FlightLogDataOptions?clientId=${clientId}&searchAllClients=${searchAllClients}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data);
}

export function getFlightLog(clientId, searchAllClients, accessToken) {
	return fetch(aerialApiUri + "Flights/FlightLog?clientId=" + clientId + "&searchAllClients=" + searchAllClients, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

export async function deleteFlight(flightId, clientId, accessToken) {
	var deleteFlightImages = await fetch(`${imageApiUri}Delete/Flight?flightId=${flightId}&clientId=${clientId}`, {
		method: "DELETE",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	const deleteImageRes = await deleteFlightImages;

	if (deleteImageRes.ok === true) {
		var deleteFlight = fetch(aerialApiUri + "Flights?flightId=" + flightId + "&clientId=" + clientId, {
			method: "DELETE",
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		}).then((res) => res);

		return await deleteFlight;
	}

	return deleteImageRes;
}

export function getOrthosForFlight(flightId, accessToken) {
	return fetch(aerialApiUri + "OrthoUploadData?flightId=" + flightId, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data);
}

export function getViewerOrthoOptions(flightId, fieldId, trialId, clientId, accessToken) {
	return fetch(
		`${aerialApiUri}OrthoUploadData/GetViewerOrthoOptions?flightId=${flightId}&fieldId=${fieldId}&trialId=${trialId}&clientId=${clientId}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	)
		.then((res) => res.json())
		.then((data) => data.data);
}

export function downloadUploadedOrtho(orthoId, fileName, clientId, accessToken) {
	const downloadOrthoPromise = new Promise(function (resolve, reject) {
		resolve(
			fetch(`${imageApiUri}Download/GetFileSASUri?flightImageId=${orthoId}&clientId=${clientId}`, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			})
				.then((res) => {
					if (res.ok === false) {
						reject(res);
					} else {
						return res.json();
					}
				})
				.then(async (data) => {
					await orthoApi.handleSasToken(data, fileName);
				}),
		);
	});

	return downloadOrthoPromise;
}

export function deleteUploadedOrtho(orthoId, clientId, accessToken) {
	// eslint-disable-next-line
	const deleteOrthoPromise = new Promise(function (resolve, reject) {
		resolve(
			fetch(`${imageApiUri}Delete?flightImageId=${orthoId}&clientId=${clientId}`, {
				method: "DELETE",
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			}).then((res) => res),
		);
	});
	return deleteOrthoPromise;
}

export function deleteFlightElevationImage(flightElevationImageId, clientId, accessToken) {
	// eslint-disable-next-line
	const deleteOrthoPromise = new Promise(function (resolve, reject) {
		resolve(
			fetch(
				`${imageApiUri}Delete/FlightElevationImage?flightElevationImageId=${flightElevationImageId}&clientId=${clientId}`,
				{
					method: "DELETE",
					headers: {
						Authorization: `Bearer ${accessToken}`,
					},
				},
			).then((res) => res),
		);
	});
	return deleteOrthoPromise;
}

export function getExistingPlots(flightId, clientId, accessToken) {
	return fetch(`${aerialApiUri}Flights/GetExistingPlots?flightId=${flightId}&clientId=${clientId}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => res.json())
		.then((data) => data.data);
}

export function GetPlotAnalysisStatusForFlight(flightId, clientId, accessToken) {
	return fetch(`${aerialApiUri}Flights/GetPlotAnalysisStatusForFlight?flightId=${flightId}&clientId=${clientId}`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

/**
 *
 * @param {string?} flightId
 * @param {string?} fieldId
 * @param {string?} trialId
 * @param {string} clientId
 * @param {string} accessToken
 * @returns {Promise<>}
 */
export async function getViewerOrthoOptionsAsync(flightId, fieldId, trialId, clientId, accessToken) {
	const res = await fetch(
		`${aerialApiUri}OrthoUploadData/GetViewerOrthoOptions?clientId=${clientId}${flightId ? "&flightId=" + flightId : ""}${fieldId ? "&fieldId=" + fieldId : ""}${trialId ? "&trialId=" + trialId : ""}`,
		{
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		},
	);

	if (!res.ok) {
		throw new Error("failed to fetch ortho options");
	}

	const data = res.json();
	return data;
}
